import React, { useState } from "react";

// Gồm các icon : AvatarAdmin,IconAdminOther,IconRefresh,IconTrash

export const AvatarAdmin=()=> {
  return (
    <div>
      <svg
        width="50"
        height="50"
        viewBox="0 0 81 78"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M79.5 39C79.5 59.6578 62.093 76.5 40.5 76.5C18.907 76.5 1.5 59.6578 1.5 39C1.5 18.3422 18.907 1.5 40.5 1.5C62.093 1.5 79.5 18.3422 79.5 39Z"
          fill="white"
          stroke="black"
          strokeWidth="3"
        />
        <path
          d="M63.1733 57.9695C60.0935 54.826 56.3561 52.3174 52.1965 50.6016C48.0368 48.8858 43.5451 48 39.0042 48C34.4632 48 29.9715 48.8858 25.8119 50.6016C21.6522 52.3174 17.9148 54.826 14.835 57.9695C14.3595 58.4648 7.9118 65.725 11.4995 63.5L14.835 68C14.8451 68.712 17.2145 69.9999 17.7526 70.5C18.2906 71.0001 19.7441 71.5001 20.5 71.5L38.5045 76.1973L58.7526 72.4873C59.515 72.4873 60.2196 69.2099 62.2526 70.5C62.7917 69.9921 63.9208 69.4156 63.9208 68.6973L69 65C68.9847 64.3447 63.6402 58.4555 63.1733 57.9695Z"
          fill="black"
        />
        <path
          d="M40.4997 43.6945C47.9095 43.6945 53.9163 38.0359 53.9163 31.0556C53.9163 24.0754 47.9095 18.4167 40.4997 18.4167C33.0899 18.4167 27.083 24.0754 27.083 31.0556C27.083 38.0359 33.0899 43.6945 40.4997 43.6945Z"
          fill="black"
        />
      </svg>
    </div>
  );
}

export const IconAdmin=()=> {
  
  return (
    <div>
      <svg
        width="33"
        height="33"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 5C16.2361 5 17.4445 5.36656 18.4723 6.05331C19.5001 6.74007 20.3012 7.71619 20.7743 8.85823C21.2473 10.0003 21.3711 11.2569 21.1299 12.4693C20.8888 13.6817 20.2935 14.7953 19.4194 15.6694C18.5453 16.5435 17.4317 17.1388 16.2193 17.3799C15.0069 17.6211 13.7503 17.4973 12.6082 17.0242C11.4662 16.5512 10.4901 15.7501 9.80332 14.7223C9.11656 13.6945 8.75 12.4861 8.75 11.25C8.75 9.5924 9.40848 8.00269 10.5806 6.83058C11.7527 5.65848 13.3424 5 15 5ZM15 2.5C13.2694 2.5 11.5777 3.01318 10.1388 3.97464C8.69983 4.9361 7.57832 6.30267 6.91606 7.90152C6.25379 9.50037 6.08051 11.2597 6.41813 12.957C6.75575 14.6544 7.58911 16.2135 8.81282 17.4372C10.0365 18.6609 11.5956 19.4942 13.293 19.8319C14.9903 20.1695 16.7496 19.9962 18.3485 19.3339C19.9473 18.6717 21.3139 17.5502 22.2754 16.1112C23.2368 14.6723 23.75 12.9806 23.75 11.25C23.75 8.92936 22.8281 6.70376 21.1872 5.06282C19.5462 3.42187 17.3206 2.5 15 2.5Z"
          fill="#12B0DF"
        />
        <path
          d="M27.5 37.5H25V31.25C25 29.5924 24.3415 28.0027 23.1694 26.8306C21.9973 25.6585 20.4076 25 18.75 25H11.25C9.5924 25 8.00269 25.6585 6.83058 26.8306C5.65848 28.0027 5 29.5924 5 31.25V37.5H2.5V31.25C2.5 28.9294 3.42187 26.7038 5.06282 25.0628C6.70376 23.4219 8.92936 22.5 11.25 22.5H18.75C21.0706 22.5 23.2962 23.4219 24.9372 25.0628C26.5781 26.7038 27.5 28.9294 27.5 31.25V37.5Z"
          fill="#12B0DF"
        />
        <path
          d="M31.25 20.225L28.0125 16.9875L26.25 18.75L31.25 23.75L40 15L38.2375 13.2375L31.25 20.225Z"
          fill="#12B0DF"
        />
      </svg>
    </div>
  );
}

export const IconAdminOther=()=> {
  const [sizeIcon,setSizeIcon]=useState(18);
  const [colorIcon,setColorIcon]=useState('black')
  return (
    <div onMouseOver={()=>{
        setSizeIcon(23);
        setColorIcon('blue');
    }}
    onMouseOut={()=>{
      setSizeIcon(18);
      setColorIcon('black');
    }} className={sizeIcon===23?"-ml-1":""}>
      <svg
        width={sizeIcon}
        height={sizeIcon}
        viewBox="0 0 61 58"
        fill={colorIcon}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M53.6775 47.4181C56.7742 43.8544 58.9279 39.6296 59.9566 35.1013C60.9852 30.5729 60.8585 25.8742 59.5871 21.4026C58.3158 16.931 55.9372 12.8181 52.6526 9.41179C49.368 6.00546 45.274 3.40595 40.7169 1.83315C36.1598 0.260346 31.2738 -0.23947 26.472 0.37598C21.6703 0.991429 17.0942 2.70404 13.1308 5.36893C9.16739 8.03383 5.9333 11.5726 3.70211 15.6859C1.47092 19.7992 0.308268 24.366 0.312512 29C0.31414 35.7365 2.79596 42.2573 7.32248 47.4181L7.27936 47.4532C7.43029 47.6265 7.60279 47.775 7.75804 47.9461C7.95211 48.1586 8.16126 48.3586 8.36179 48.5649C8.96554 49.1919 9.58654 49.7941 10.2377 50.3593C10.4361 50.5325 10.6409 50.6934 10.8415 50.8584C11.5315 51.4276 12.2409 51.968 12.9762 52.4713C13.071 52.5331 13.1573 52.6136 13.2522 52.6775V52.6528C18.3023 56.0521 24.3269 57.8765 30.5022 57.8765C36.6774 57.8765 42.702 56.0521 47.7522 52.6528V52.6775C47.847 52.6136 47.9311 52.5331 48.0282 52.4713C48.7613 51.966 49.4729 51.4276 50.1629 50.8584C50.3634 50.6934 50.5682 50.5305 50.7666 50.3593C51.4178 49.7921 52.0388 49.1919 52.6425 48.5649C52.8431 48.3586 53.0501 48.1586 53.2463 47.9461C53.3994 47.775 53.574 47.6265 53.725 47.4511L53.6775 47.4181ZM30.5 12.5C32.4191 12.5 34.2951 13.0444 35.8908 14.0642C37.4865 15.084 38.7301 16.5336 39.4645 18.2295C40.1989 19.9254 40.3911 21.7916 40.0167 23.5919C39.6423 25.3923 38.7182 27.0461 37.3612 28.3441C36.0042 29.6421 34.2752 30.5261 32.393 30.8842C30.5108 31.2423 28.5598 31.0585 26.7868 30.356C25.0138 29.6535 23.4984 28.4639 22.4322 26.9377C21.366 25.4114 20.7969 23.6169 20.7969 21.7813C20.7969 19.3197 21.8192 16.959 23.6389 15.2184C25.4586 13.4779 27.9266 12.5 30.5 12.5V12.5ZM13.2651 47.4181C13.3025 44.71 14.4531 42.1249 16.4679 40.2219C18.4827 38.319 21.1998 37.2514 24.0313 37.25H36.9688C39.8002 37.2514 42.5173 38.319 44.5321 40.2219C46.5469 42.1249 47.6975 44.71 47.7349 47.4181C43.0059 51.4943 36.8658 53.7502 30.5 53.7502C24.1342 53.7502 17.9941 51.4943 13.2651 47.4181V47.4181Z"
          fill={colorIcon}
        />
      </svg>
    </div>
  );
}

export const IconRefresh=()=> {
  return (
    <div>
      <svg
        width="45"
        height="45"
        viewBox="0 0 512 512"
        fill="#00C5FF"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M256 48C141.31 48 48 141.32 48 256C48 370.86 141.14 464 256 464C370.69 464 464 370.69 464 256C464 141.13 370.87 48 256 48ZM350 267C350 285.591 344.487 303.765 334.158 319.224C323.829 334.682 309.148 346.73 291.972 353.845C274.796 360.959 255.896 362.821 237.662 359.194C219.427 355.567 202.678 346.614 189.532 333.468C176.386 320.322 167.433 303.573 163.806 285.339C160.179 267.104 162.041 248.204 169.155 231.028C176.27 213.852 188.318 199.171 203.776 188.842C219.235 178.513 237.409 173 256 173H260.21L236.21 149L256 129.2L315.8 189L256 248.8L236.2 229L264.12 201.08C261.72 201 259 201 256 201C242.946 201 230.186 204.871 219.332 212.123C208.479 219.375 200.019 229.683 195.024 241.743C190.029 253.803 188.722 267.073 191.268 279.876C193.815 292.679 200.101 304.439 209.331 313.669C218.561 322.899 230.321 329.185 243.124 331.732C255.927 334.278 269.197 332.971 281.257 327.976C293.317 322.981 303.625 314.521 310.877 303.668C318.129 292.814 322 280.054 322 267V253H350V267Z"
          fill="#00C5FF"
        />
      </svg>
    </div>
  );
}

export const IconTrash=()=> {
  const [colorIcon,setColorIcon]=useState('black');
  const [sizeIcon,setSizeIcon]=useState(15);
  return (
    <div className={sizeIcon===20?"-ml-1":""}
      onMouseOver={()=>{
        setColorIcon('red');
        setSizeIcon(20);
      }}
      onMouseOut={()=>{setColorIcon('black');
      setSizeIcon(15);}}>
      <svg
        width={sizeIcon}
        height={sizeIcon}
        viewBox="0 0 34 37"
        fill={colorIcon}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.55769 3.21617C1.87935 3.21617 1.22879 3.46738 0.749131 3.91453C0.26947 4.36169 0 4.96817 0 5.60055V7.98492C0 8.6173 0.26947 9.22378 0.749131 9.67094C1.22879 10.1181 1.87935 10.3693 2.55769 10.3693H3.83654V31.8287C3.83654 33.0935 4.37548 34.3064 5.3348 35.2007C6.29412 36.0951 7.59524 36.5975 8.95192 36.5975H24.2981C25.6548 36.5975 26.9559 36.0951 27.9152 35.2007C28.8745 34.3064 29.4135 33.0935 29.4135 31.8287V10.3693H30.6923C31.3706 10.3693 32.0212 10.1181 32.5009 9.67094C32.9805 9.22378 33.25 8.6173 33.25 7.98492V5.60055C33.25 4.96817 32.9805 4.36169 32.5009 3.91453C32.0212 3.46738 31.3706 3.21617 30.6923 3.21617H21.7404C21.7404 2.58379 21.4709 1.97731 20.9913 1.53016C20.5116 1.083 19.861 0.831787 19.1827 0.831787L14.0673 0.831787C13.389 0.831787 12.7384 1.083 12.2587 1.53016C11.7791 1.97731 11.5096 2.58379 11.5096 3.21617H2.55769ZM10.2308 12.7537C10.5699 12.7537 10.8952 12.8793 11.135 13.1029C11.3749 13.3264 11.5096 13.6297 11.5096 13.9459V30.6365C11.5096 30.9527 11.3749 31.256 11.135 31.4795C10.8952 31.7031 10.5699 31.8287 10.2308 31.8287C9.8916 31.8287 9.56632 31.7031 9.32649 31.4795C9.08666 31.256 8.95192 30.9527 8.95192 30.6365V13.9459C8.95192 13.6297 9.08666 13.3264 9.32649 13.1029C9.56632 12.8793 9.8916 12.7537 10.2308 12.7537ZM16.625 12.7537C16.9642 12.7537 17.2895 12.8793 17.5293 13.1029C17.7691 13.3264 17.9038 13.6297 17.9038 13.9459V30.6365C17.9038 30.9527 17.7691 31.256 17.5293 31.4795C17.2895 31.7031 16.9642 31.8287 16.625 31.8287C16.2858 31.8287 15.9605 31.7031 15.7207 31.4795C15.4809 31.256 15.3462 30.9527 15.3462 30.6365V13.9459C15.3462 13.6297 15.4809 13.3264 15.7207 13.1029C15.9605 12.8793 16.2858 12.7537 16.625 12.7537ZM24.2981 13.9459V30.6365C24.2981 30.9527 24.1633 31.256 23.9235 31.4795C23.6837 31.7031 23.3584 31.8287 23.0192 31.8287C22.6801 31.8287 22.3548 31.7031 22.1149 31.4795C21.8751 31.256 21.7404 30.9527 21.7404 30.6365V13.9459C21.7404 13.6297 21.8751 13.3264 22.1149 13.1029C22.3548 12.8793 22.6801 12.7537 23.0192 12.7537C23.3584 12.7537 23.6837 12.8793 23.9235 13.1029C24.1633 13.3264 24.2981 13.6297 24.2981 13.9459Z"
          fill={colorIcon}
        />
      </svg>
    </div>
  );
}

